export const AUTOCOMPLETE_MAX_AMOUNT_GOOGLE_GEOCODES = 2;
export const AUTOCOMPLETE_FALLBACK_GOOGLE_POIS_LIMIT = 5;
